import { useEffect, useState } from 'react';
import { useAuth } from 'src/contexts/auth';
import api from 'src/services/api';

export type AlertaExcesso = {
    tipo: 'EXCESSO_CAPACIDADE';
    veiculo: string;
    placa: string;
    litros: number;
    capacidade: number;
    hora: string;
};

export type AlertaDuplo = {
    tipo: 'DUPLO_ABASTECIMENTO';
    veiculo: string;
    placa: string;
    hora1: string;
    hora2: string;
    litros1: number;
    litros2: number;
    diffHoras: number;
};

export type AlertasFraude = {
    excessoCapacidade: AlertaExcesso[];
    duploAbastecimento: AlertaDuplo[];
    total: number;
};

const empty: AlertasFraude = {
    excessoCapacidade: [],
    duploAbastecimento: [],
    total: 0,
};

export const useAlertasFraude = () => {
    const { userAgencyId } = useAuth();
    const [data, setData] = useState<AlertasFraude>(empty);
    const [loading, setLoading] = useState(false);

    const fetch = () => {
        if (!userAgencyId) return;
        setLoading(true);
        api.get(`/dashboard-alertas-fraude/${userAgencyId}`)
            .then(res => { setData(res.data); setLoading(false); 
                console.log('AlertasFraudeController.fetch response:', res.data);
            })
            .catch(err => { console.error(err); setLoading(false); });
    };

    useEffect(() => { fetch(); }, [userAgencyId]);

    return { data, loading, refetch: fetch };
};
